// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-Steps-___Steps-module__cellUpdateRank {
  height: 100%;
  width: 100%;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.app-pages-Project-Settings-Steps-___Steps-module__container .react-draggable.react-draggable-dragging {
  background-color: #fff;
  z-index: 2;
}

.app-pages-Project-Settings-Steps-___Steps-module__item {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: space-around;
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:not(.app-pages-Project-Settings-Steps-___Steps-module__first) {
  border-left: var(--mainBorder);
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:first-child {
  min-width: 200px;
  max-width: 250px;
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:nth-child(2) {
  max-width: 100px;
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:nth-child(3) {
  min-width: 200px;
  max-width: 400px;
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:nth-child(4) {
  min-width: 300px;
  max-width: 500px;
}

.app-pages-Project-Settings-Steps-___Steps-module__item > div:last-child {
  max-width: 100px;
}

.app-pages-Project-Settings-Steps-___Steps-module__itemCell {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 50%;
  min-height: 35px;
  flex: 1;
}

.app-pages-Project-Settings-Steps-___Steps-module__title {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-Steps-___Steps-module__tableItem {
  position: relative;
  margin: 2px;
  background-color: #555;
  color: #fff;
  padding: 3px 7px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/Steps/Steps.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".cellUpdateRank {\n  height: 100%;\n  width: 100%;\n  cursor: ns-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: all;\n}\n\n.container :global(.react-draggable.react-draggable-dragging) {\n  background-color: #fff;\n  z-index: 2;\n}\n\n.item {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-content: space-around;\n}\n\n.item > div:not(.first) {\n  border-left: var(--mainBorder);\n}\n\n.item > div:first-child {\n  min-width: 200px;\n  max-width: 250px;\n}\n\n.item > div:nth-child(2) {\n  max-width: 100px;\n}\n\n.item > div:nth-child(3) {\n  min-width: 200px;\n  max-width: 400px;\n}\n\n.item > div:nth-child(4) {\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.item > div:last-child {\n  max-width: 100px;\n}\n\n.itemCell {\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 50%;\n  min-height: 35px;\n  flex: 1;\n}\n\n.title {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.tableItem {\n  position: relative;\n  margin: 2px;\n  background-color: #555;\n  color: #fff;\n  padding: 3px 7px;\n  border-radius: 3px;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellUpdateRank": `app-pages-Project-Settings-Steps-___Steps-module__cellUpdateRank`,
	"container": `app-pages-Project-Settings-Steps-___Steps-module__container`,
	"item": `app-pages-Project-Settings-Steps-___Steps-module__item`,
	"first": `app-pages-Project-Settings-Steps-___Steps-module__first`,
	"itemCell": `app-pages-Project-Settings-Steps-___Steps-module__itemCell`,
	"title": `app-pages-Project-Settings-Steps-___Steps-module__title`,
	"tableItem": `app-pages-Project-Settings-Steps-___Steps-module__tableItem`
};
export default ___CSS_LOADER_EXPORT___;
